import { ajax } from '../../../services/helper'

class ApiService {
    


    getProductsData = (city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/products/getList?city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getCityDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/cities/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    



    
}

export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Products/services/apiservices.js